<template>
  <div class="container">
    <app-more title="媒体报道" more="更多报道" :link="{path: '/action'}" ></app-more>
    <div class="news-box">
      <div class="news-left" v-if="actionData&&actionData[0]">
        <router-link  :to="{name:'adetail',params:{id:actionData[0]['id']}}" tag="a"><img :src="actionData[0]['img']"/></router-link>
        <div class="news-msg">
          <router-link  :to="{name:'adetail',params:{id:actionData[0]['id']}}" tag="a">{{ actionData[0]['title'] }}
          </router-link>
          <p>{{actionData[0]['source']}} | {{actionData[0]['create_time']}} </p>
        </div>
      </div>
      <div class="news-right">
        <div  v-for="(s, i) of actionData" :key="i">
          <div class="news-msg" v-if="i>0">
            <router-link  :to="{name:'adetail',params:{id:s.id}}" tag="a">{{s.title}}
          </router-link>
        
          <p>{{s.source}} | {{s.create_time}}</p></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import more from "../public/more.vue";
export default {
  components: {
    "app-more": more
  },data() {
    return {
      actionData:[],
       get: {
        pi: 1,
        ps: 5,
        name: "dynamic"
      }
    }
  },
  created() {
    this.getData();
  },
  methods: {
     getData() {
      this.$http.get("/Index/index/lists", { params: this.get }).then(res => {
        this.actionData = res.datas;
      });
    }
  },
};
</script>
<style lang="less" scoped>
.news-box {
   img{max-width:100%;}
  border-bottom: 2px dotted #dcdcdc;
  display: flex;
  padding-bottom: 80px;
  justify-content: space-between;
  .news-left {
    width: 900/1640 * 100%;
  }
  .news-right {
    width: 625/1640 * 100%;
  }
  .news-msg {
    margin-top: 40px;
    font-size: 18px;
    font-weight: 600;
    line-height: 37px;
    color: rgba(124, 124, 124, 1);
    opacity: 1;
    a {
      height: 56px;
      font-size: 20px;
      display: block;
      font-weight: 400;
      line-height: 28px;
      overflow: hidden;
      color: rgba(0, 0, 0, 1);
      opacity: 1;
    }
    p {
      margin-bottom: 20px;
      padding-bottom: 20px;
    }
  }
}

@media (max-width: 768px) {
  .news-box {
    flex-wrap: wrap;
    padding-bottom: 20px;
    .news-msg {
      padding:0 10px;
      margin-top: 20px;
      font-size: 14px;
      line-height: 20px;
      color: #000000;
      font-weight: 300;
      opacity: 1;
      border-bottom: 1px solid #A6A6A6;
      a {
        height: auto;
        display: block;
        line-height: 18px;
        overflow: hidden;
       font-size: 14px;
      line-height: 20px;
      color: #000000;
      font-weight: 300;
        opacity: 1;
      }
      p {
        margin-bottom: 0px;
        padding: 10px 0;
      }
    }
    .news-left {
      width: 100%;
    }
    .news-right {
      width: 100%;
    }
  }
}
</style>